import React, { useMemo } from 'react';
import { KeyMetricChartData } from 'src/components/organisms/KeyMetricChart';
import { getAggregateLevelData } from 'src/features/MM/utils/getAggregateLevelData';
import { AggregateLevel } from 'src/types';
import { useMMDataContext } from '../../../contexts/MMDataContext';
import { KeyMetricItem } from 'src/features/MM/components/molecules/KeyMetricItem';
import { Icon } from 'src/components/atoms/Icon';
import { calculateTrendFromTimeSeries } from 'src/features/MM/utils/calculateTrendFromTimeSeries';

type RomiProps = {
  aggregateLevel: AggregateLevel;
};

export const Romi: React.FC<RomiProps> = ({ aggregateLevel }) => {
  const { romi } = useMMDataContext();

  const keyMetricData: KeyMetricChartData = useMemo(() => {
    return {
      isLoading: romi.isLoading,
      isError: romi.isError,
      name: 'ROMI',
      isEuro: false,
      summaryValue: romi.total,
      data: getAggregateLevelData(romi, aggregateLevel),
    };
  }, [aggregateLevel, romi]);

  const { upOrDown, upOrDownValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricItem
      title="ROMI"
      upOrDown={upOrDown}
      upOrDownValue={upOrDownValue}
      value={keyMetricData.summaryValue}
      icon={<Icon iconName="growth" />}
    />
  );
};
